import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subject } from 'rxjs';

export const onClickLoginSub = new Subject<any>();

@Component({
  selector: 'app-wop-spinner',
  templateUrl: './wop-spinner.component.html',
  styleUrls: ['./wop-spinner.component.scss'],
  encapsulation: ViewEncapsulation.None
})


export class WopSpinnerComponent  {

  constructor() { }

 



  
}

